export const hasAccessBySystemRole = (userState, permissions, permissionType) => {
    var _a, _b;
    return !!((_b = (_a = permissions[permissionType]) === null || _a === void 0 ? void 0 : _a.systemRoles) === null || _b === void 0 ? void 0 : _b.includes(userState.systemRole));
};
